import Vue from 'vue';
export const BarCodeSupport = new Vue();